const swiper02 = new Swiper ('.pack-container-carousel', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1.2,
    freeMode: true,
    spaceBetween: 30,
    breakpoints: {
      769:{
            slidesPerView: 3,
        },
        426:{
            slidesPerView: 1.7,
        }
    }
})
